class CentrePlan {
    constructor($container) {
        this.$container = $container.querySelector('.centre-plan-inner');

        if (!this.$container)
            return;

        this.$background = this.$container.querySelector('.centre-plan-bg');
        this.$links = this.$container.querySelector('.centre-plan-links');

        if (!this.$background || !this.$links)
            return;

        this.awaitLoad();
    }

    awaitLoad() {
        let img = new Image();
        img.src = this.$background.src;
        img.onload = () => {
            img.style.position = 'absolute';
            document.body.appendChild(img);
            setTimeout(()=> {
                this.bgSize = `${img.width} ${img.height}`;
                img.remove();
                this.init();
            }, 100);
        }
    }

    init() {
        this.$container.insertAdjacentHTML('beforeend', this.buildSVG());
        [...this.$container.querySelectorAll('.area-highlight')].forEach(el =>{
            el.addEventListener('click', e => {
                let url = e.target.dataset['href'];

                if (url) {
                    window.location = url;
                }
            });
        })
    }

    buildSVG() {
        let svg = '';

        [...this.$links.querySelectorAll('area')].forEach(area => {
           let coords = area.getAttribute('coords'),
               href = area.getAttribute('href'),
               title = area.getAttribute('alt');

           svg += `<polygon class="area-highlight" points="${coords}" data-href="${href}"><title>${title}</title></polygon>`;
        });

        return `<svg class="centre-plan-highlight" width="100%" height="100%" viewBox="0 0 ${this.bgSize}" preserveAspectRatio="" version="1.1" xmlns="http://www.w3.org/2000/svg">${svg}</svg>`;
    }
}

export default CentrePlan;
